export const cookieOptions = {
  path: '/'
}
